import { NumberInputBase } from 'app/shared/elements/forms/number-input-base';
import { bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@bindable({ name: 'value', defaultBindingMode: bindingMode.twoWay })
@bindable.numberNull({ name: 'min' })
@bindable.numberNull({ name: 'max' })
@bindable.numberNull({ name: 'step' })
@bindable.numberNull({ name: 'precision' })
@bindable.stringNull({ name: 'label' })
@bindable.stringNull({ name: 'placeholder' })
@bindable.stringNull({ name: 'icon' })
@bindable.booleanAttr({ name: 'required' })
@bindable.booleanAttr({ name: 'readonly' })
@bindable.booleanAttr({ name: 'disabled' })
@bindable.stringNull({ name: 'autocomplete' })
@bindable.stringNull({ name: 'testName' })
@bindable.stringNull({ name: 'testPrefix' })
export class EssCurrencyCustomElement extends NumberInputBase {
    public testPrefix = 'cur';
    public icon = 'ui:icons.dollar';
    protected precision = 2;
}
